import toKebabCase from '@anwb/to-kebab-case';
const DATA_ATTRIBUTE = 'data-render-target';
export function createQuerySelector(id) {
    return `[${DATA_ATTRIBUTE}=${id}]`;
}
/**
 * Converts a camelCase attribute name to a kebab-case attribute name.
 */
export function normalizeAttributeName(name) {
    if (name === 'className') {
        return 'class';
    }
    if (name === 'htmlFor') {
        return 'for';
    }
    return toKebabCase(name);
}
export const createRenderTarget = ({ id, attributes = {}, }) => {
    if (typeof document === 'undefined') {
        return null;
    }
    let renderTarget = document.querySelector(createQuerySelector(id));
    if (renderTarget === null) {
        renderTarget = document.createElement('div');
        Object.entries(attributes).forEach(([name, value]) => {
            renderTarget.setAttribute(normalizeAttributeName(name), value);
        });
        renderTarget.setAttribute(DATA_ATTRIBUTE, id);
        document.body.appendChild(renderTarget);
    }
    return renderTarget;
};
export function removeRenderTarget(id) {
    if (typeof document === 'undefined') {
        return;
    }
    const renderTarget = document.querySelector(createQuerySelector(id));
    if (renderTarget !== null) {
        document.body.removeChild(renderTarget);
    }
}
//# sourceMappingURL=renderTarget.js.map